/**
 * setMostRecentlyUpdatedModelPageContext
 *
 * Sets the most recently updated model's page context in Redux state.
 * The location string is parsed by the RTK Slice reducer into page/size/sort/order.
 *
 * Backed by the session RTK Slice.
 *
 * @see src/store/slices/sessionSlice.ts
 */
import { getStore } from '@/store/store-proxy';
import { setMostRecentlyUpdatedModelPageContext as setPageContext } from '@/store/slices/sessionSlice';
/**
 * Sets the most recently updated model ID along with a location string
 * that encodes page context (page, size, sort, order) as query parameters.
 *
 * @param modelId - The model ID to set.
 * @param location - Optional location string with query params (e.g. "?page=1&size=10&sort=name&order=asc").
 */
export const setMostRecentlyUpdatedModelPageContext = (modelId, location) => {
    getStore().dispatch(setPageContext({ modelId, location }));
};
